import {isNull} from "../../util";

export default {
    name : 'urDataGridSummary',
    inject : ['gridInfo'],
    watch: {
        "gridInfo.updated" : {immediate: true, handler(v, w) {
            window.requestAnimationFrame(() => {
                this.$forceUpdate()
            })
        }},
    },
    methods: {
        flattenData() {
            var data = this.gridInfo.data;
            if(isNull(this.gridInfo.opts.grouping)) {
                return data;
            } else {
                return this.concatChildren({children:data});
            }
        },
        concatChildren(node) {
            if(node.leaf) {
                return node.children
            } else {
                return node.children.reduce((acc, ch)=>{
                    acc.push(...this.concatChildren(ch))
                    return acc;
                },[])
            }
        }
    },
    render(h) {
        // 1. get summary slot
        var slot = this.gridInfo.slot.summary, vNode;
        if(!slot) return null;
        vNode = slot({
                gridInfo:this.gridInfo,
                data : this.flattenData(),
                nodes:this.gridInfo.data
        })
        // 2. wrapper options
        var opts = {};
        opts.staticClass = 'ur-data-grid__summary';
        opts.style = {'height':this.gridInfo.opts.summaryHeight+"px"}
        return h('div', opts, [vNode])
    }
}